(function () {
  'use strict';

  const CONFIG_ID = "LSCustomDildoConfig";

  function readConfig() {
    const node = document.getElementById(CONFIG_ID);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('[Love Smiths] Invalid custom dildo configuration:', error);
      return null;
    }
  }

  function init(config) {
    if (!config || !config.sectionId) return;

  /* ---------- Gallery fade swap ---------- */
  const thumbnails = document.querySelectorAll(".thumbnail");
  const mainBanner = document.getElementById("main-banner");
  function swapMainSrc(newSrc){
    if(!mainBanner||!newSrc) return;
    mainBanner.classList.add("is-fading");
    const img=new Image();
    img.onload=()=>{ 
      mainBanner.src=newSrc;
      mainBanner.srcset=newSrc; // force override
      mainBanner.removeAttribute("sizes"); // optional: let browser pick
      requestAnimationFrame(()=>mainBanner.classList.remove("is-fading")); 
    };
    img.onerror=()=>mainBanner.classList.remove("is-fading");
    img.src=newSrc;
  }
  thumbnails.forEach(t=>{
    t.addEventListener("click",function(){
      thumbnails.forEach(x=>x.classList.remove("selected"));
      this.classList.add("selected");
      swapMainSrc(this.getAttribute("data-large")||this.getAttribute("src"));
    });
      });
  /* --- Mobile swipe to change main image (uses swapMainSrc) --- */
(function () {
  // reuse existing variables from your script
  if (!mainBanner) return;

  const thumbs = Array.from(document.querySelectorAll(".thumbnail"));
  if (!thumbs.length) return;

  // start from currently selected thumbnail
  let currentIndex = Math.max(0, thumbs.findIndex(el => el.classList.contains("selected")));
  if (currentIndex === -1) currentIndex = 0;

  let startX = 0, startY = 0, swiping = false;

  function goTo(idx) {
    currentIndex = (idx + thumbs.length) % thumbs.length;
    const t = thumbs[currentIndex];
    thumbs.forEach(x => x.classList.remove("selected"));
    t.classList.add("selected");

    const newSrc = t.getAttribute("data-large") || t.getAttribute("src");
    // IMPORTANT: use your existing function so src, srcset, sizes, and fade are handled
    swapMainSrc(newSrc);
  }

  mainBanner.addEventListener("touchstart", (e) => {
    if (!e.touches || !e.touches.length) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    swiping = true;
  }, { passive: true });

  mainBanner.addEventListener("touchmove", (e) => {
    if (!swiping) return;
    const dx = e.touches[0].clientX - startX;
    const dy = e.touches[0].clientY - startY;
    // lock when horizontal intent is clear
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      e.preventDefault();
    }
  }, { passive: false });

  mainBanner.addEventListener("touchend", (e) => {
    if (!swiping) return;
    swiping = false;

    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;

    // swipe threshold + horizontal dominance
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) goTo(currentIndex + 1);   // swipe left → next
      else goTo(currentIndex - 1);          // swipe right → previous
    }
  });
})();


  /* ---------- Form elements ---------- */
  const form = document.getElementById(`product-form-${config.sectionId}`);
  if (!form) return;
const hiddenInput = form.querySelector('input[name="id"]');
const addToCartBtn = document.getElementById(`add-to-cart-${config.sectionId}`);
const hint = document.getElementById(`selection-hint-${config.sectionId}`);
const defaultHintText = hint ? hint.textContent.trim() : "";

function setCartVisibility(showButton, hintText = defaultHintText) {
  if (addToCartBtn) {
    addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
    addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
  }

  if (hint) {
    hint.hidden = showButton;
    if (!showButton) {
      hint.textContent = hintText;
    }
  }
}

const propFirmness = document.getElementById("prop-firmness");
const propPour     = document.getElementById("prop-pour-style");

// Generic colours (marble etc.)
const propC1 = document.getElementById("prop-colour-1");
const propC2 = document.getElementById("prop-colour-2");
const propC3 = document.getElementById("prop-colour-3");

// Shade / area colours
const propTip   = document.getElementById("prop-tip-colour");
const propShaft = document.getElementById("prop-shaft-colour");
const propBase  = document.getElementById("prop-base-colour");

// Split enhancer
const propSplitTarget = document.getElementById("prop-split-target");
const propSplitStyle  = document.getElementById("prop-split-style");
const propSplitTop    = document.getElementById("prop-split-top");
const propSplitBottom = document.getElementById("prop-split-bottom");
const propSplitShaftColour = document.getElementById("prop-split-shaft-colour");
const propSplitBaseColour  = document.getElementById("prop-split-base-colour");




const variants = Array.isArray(config.variants) ? config.variants : [];

  const optionBtns = form.querySelectorAll(".option-btn[data-variant='true']");
  const firmnessBtns = form.querySelectorAll(".btn-firmness");
  const pourBtns = form.querySelectorAll(".pour-style-btn");

  const customPanel = document.getElementById("customisation-panel");
  const swatchSetsContainer = document.getElementById("swatch-sets");
  const prototype = document.getElementById("swatch-prototype");
  const swatchSource = document.getElementById("swatch-source");
  const pourWrapper = document.getElementById("pour-style-wrapper");
  const livePreview = document.getElementById("live-preview");
  const instructionEl = document.getElementById("preview-instructions");

  /* ---------- Helpers ---------- */
  function slugify(val){
    return String(val||"").toLowerCase().trim().replace(/\s+/g,"-");
  }

  function canonicalSlugify(val) {
    return String(val || "")
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ł/g, "l")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function arraysEqualCI(a,b){
    if(!a||!b||a.length!==b.length) return false;
    for(let i=0;i<a.length;i++){
      if(canonicalVariantValueByIndex(i, a[i]) !== canonicalVariantValueByIndex(i, b[i])) return false;
    }
    return true;
  }

// === Shopify option order for THIS template ===
// (Size -> Base -> How many colours?)
const groupOrder = (() => {
  const preferred = ["size", "base", "colorcount"];
  const present = new Set(
    Array.from(form.querySelectorAll(".option-btn[data-variant='true'][data-option-group]"))
      .map(b => b.dataset.optionGroup)
  );
  return preferred.filter(g => present.has(g));
})();

function getSelectedVariantOptions() {
  const total = config.optionCount;
  const out = new Array(total).fill("");

  groupOrder.forEach((group, idx) => {
    if (idx >= total) return;
    const active = form.querySelector(`.option-btn[data-variant='true'][data-option-group="${group}"].active`);
    if (active) out[idx] = active.dataset.value || "";
  });

  return out;
}
/* ==================================
   DISABLE INVALID VARIANT OPTIONS
   (size/base/colorcount combos that don't exist)
================================== */
function refreshVariantAvailability() {
  // Progressive option logic prevents circular disabling:
  // Size is independent, Base depends on Size, and colour count depends on both.
  // If an earlier choice changes, incompatible later choices are cleared.
  let pass = 0;
  let clearedSelection = false;

  do {
    clearedSelection = false;
    const selected = getSelectedVariantOptions();
    const total = config.optionCount;
    const variantBtns = form.querySelectorAll(".option-btn[data-variant='true']");

    variantBtns.forEach(btn => {
      const frame = btn.closest(".variant-frame");

      // Prefer the explicit Shopify option index supplied by Liquid.
      let idx = frame ? Number(frame.dataset.optionIndex) : -1;

      // Fallback to the known Size -> Base -> Colour count order.
      if (idx < 0 || Number.isNaN(idx)) {
        idx = groupOrder.indexOf(btn.dataset.optionGroup);
      }

      if (idx < 0 || idx >= total) {
        btn.disabled = false;
        btn.classList.remove("unavailable");
        return;
      }

      const candidateValue = btn.dataset.value || "";
      const exists = variants.some(variant => {
        for (let i = 0; i <= idx; i++) {
          const wanted = i === idx ? candidateValue : (selected[i] || "");
          if (!wanted) continue;

          const actual = variant.options[i] || "";
          if (
            canonicalVariantValueByIndex(i, actual) !==
            canonicalVariantValueByIndex(i, wanted)
          ) {
            return false;
          }
        }

        return true;
      });

      btn.disabled = !exists;
      btn.classList.toggle("unavailable", !exists);

      if (!exists && btn.classList.contains("active")) {
        btn.classList.remove("active");
        btn.setAttribute("aria-pressed", "false");
        clearedSelection = true;
      }
    });

    pass += 1;
  } while (clearedSelection && pass <= config.optionCount);
}
  function updateVariantId(){
    refreshVariantAvailability();

    const selected = getSelectedVariantOptions();
    if (selected.filter(Boolean).length !== config.optionCount) {
      hiddenInput.value = "";
      return;
    }

    const match = variants.find(v=>arraysEqualCI(v.options, selected));
    hiddenInput.value = match ? match.id : "";
  }
  function activePourStyle() {
    const btn = document.querySelector(".pour-style-btn.active");
    return btn ? btn.dataset.pourStyle : "";
  }

  function clearProperties(){
    propPour.value = "";
    propC1.value = ""; propC2.value = ""; propC3.value = "";
  }


  function getActiveColourCountButton() {
    return form.querySelector('.option-btn[data-option-group="colorcount"].active');
  }

  function isSurpriseColourButton(button) {
    if (!button) return false;
    const raw = String(button.dataset.value || button.textContent || "").trim();
    const canonical = canonicalSlugify(raw);

    // The Shopify value is "Surprise!". The no-number fallback also keeps
    // translated versions working while the other choices remain 1, 2 and 3.
    return canonical === "surprise" || !/\d/.test(raw);
  }

  function isSurpriseSelected() {
    return isSurpriseColourButton(getActiveColourCountButton());
  }

  function getSelectedColourCount() {
    const button = getActiveColourCountButton();
    if (!button || isSurpriseColourButton(button)) return 0;
    const match = String(button.dataset.value || button.textContent || "").match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function clearActiveButtons(selector) {
    form.querySelectorAll(selector).forEach(button => {
      button.classList.remove("active");
      button.setAttribute("aria-pressed", "false");
    });
  }

  function clearAllColourProperties() {
    clearProperties();
    if (propTip) propTip.value = "";
    if (propShaft) propShaft.value = "";
    if (propBase) propBase.value = "";
    if (propSplitTarget) propSplitTarget.value = "";
    if (propSplitStyle) propSplitStyle.value = "";
    if (propSplitTop) propSplitTop.value = "";
    if (propSplitBottom) propSplitBottom.value = "";
    if (propSplitShaftColour) propSplitShaftColour.value = "";
    if (propSplitBaseColour) propSplitBaseColour.value = "";
  }

  function resetDripState() {
    dripEnabled = false;
    dripColour = "";

    const dripNoButton = document.querySelector('.drip-toggle[data-value="no"]');
    const dripYesButton = document.querySelector('.drip-toggle[data-value="yes"]');

    if (dripNoButton) {
      dripNoButton.classList.add("active");
      dripNoButton.setAttribute("aria-pressed", "true");
    }
    if (dripYesButton) {
      dripYesButton.classList.remove("active");
      dripYesButton.setAttribute("aria-pressed", "false");
    }

    if (dripArea) dripArea.style.display = "none";
    if (dripHint) dripHint.style.display = "none";

    document.querySelectorAll("#drip-swatch-sets .swatch.active").forEach(swatch => {
      swatch.classList.remove("active");
      swatch.setAttribute("aria-pressed", "false");
    });

    document.querySelectorAll("#live-preview .preview-drip").forEach(node => node.remove());
  }

  function resetColourCustomisation(hidePanel = true) {
    clearActiveButtons(".pour-style-btn");
    clearAllColourProperties();
    resetDripState();

    if (swatchSetsContainer) swatchSetsContainer.innerHTML = "";
    if (pourWrapper) pourWrapper.style.display = "none";

    const splitBlock = document.getElementById("split-enhancer-block");
    if (splitBlock) splitBlock.style.display = "none";

    if (customPanel) customPanel.style.display = hidePanel ? "none" : "";
    if (instructionEl) instructionEl.textContent = window.customizerStrings.instr_start;
    updateLivePreview();
  }

  function applyColourCountSelection(button) {
    if (isSurpriseColourButton(button)) {
      // Surprise uses only the Shopify variant plus Size, Base and Firmness.
      // No pour style, swatches, split choices or drip add-on are required.
      resetColourCustomisation(true);
      return;
    }

    const count = getSelectedColourCount();
    if (customPanel) customPanel.style.display = "";
    renderSwatchSets(count, activePourStyle());
    updateLivePreview();
  }

  function syncCustomisationWithVariantSelection() {
    const countButton = getActiveColourCountButton();
    if (!countButton || isSurpriseColourButton(countButton)) {
      resetColourCustomisation(true);
    }
  }

  function addResetControl(frame, kind) {
    if (!frame || frame.querySelector(':scope > .ls-option-reset-btn')) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "ls-option-reset-btn";
    button.dataset.resetKind = kind;
    button.textContent = window.customizerStrings.reset_selection || "Reset";
    button.hidden = true;

    frame.classList.add("ls-has-reset-control");
    frame.appendChild(button);
  }

  function installResetControls() {
    form.querySelectorAll('.variant-frame[data-option-index]').forEach(frame => {
      const optionButton = frame.querySelector('.option-btn[data-variant="true"][data-option-group]');
      if (optionButton) addResetControl(frame, optionButton.dataset.optionGroup);
    });

    addResetControl(document.getElementById("firmness-frame"), "firmness");
    addResetControl(pourWrapper, "pour-style");
    addResetControl(dripBlock, "drip");
  }

  function syncResetControls() {
    form.querySelectorAll(".ls-option-reset-btn").forEach(button => {
      const kind = button.dataset.resetKind;
      let selected = false;

      if (["size", "base", "colorcount"].includes(kind)) {
        selected = !!form.querySelector(`.option-btn[data-option-group="${kind}"].active`);
      } else if (kind === "firmness") {
        selected = !!propFirmness.value;
      } else if (kind === "pour-style") {
        selected = !!activePourStyle();
      } else if (kind === "drip") {
        selected = dripEnabled || !!dripColour;
      }

      button.hidden = !selected;
    });
  }

  function clearVariantGroup(group) {
    clearActiveButtons(`.option-btn[data-option-group="${group}"]`);
  }

  function resetByKind(kind) {
    if (kind === "size") {
      clearVariantGroup("size");
      clearVariantGroup("base");
      clearVariantGroup("colorcount");
      const sizePreview = document.getElementById("size-preview");
      const basePreview = document.getElementById("base-preview");
      if (sizePreview) sizePreview.innerHTML = "";
      if (basePreview) basePreview.innerHTML = "";
      resetColourCustomisation(true);
    } else if (kind === "base") {
      clearVariantGroup("base");
      clearVariantGroup("colorcount");
      const basePreview = document.getElementById("base-preview");
      if (basePreview) basePreview.innerHTML = "";
      resetColourCustomisation(true);
    } else if (kind === "colorcount") {
      clearVariantGroup("colorcount");
      resetColourCustomisation(true);
    } else if (kind === "firmness") {
      clearActiveButtons(".btn-firmness");
      propFirmness.value = "";
    } else if (kind === "pour-style") {
      clearActiveButtons(".pour-style-btn");
      clearAllColourProperties();
      if (swatchSetsContainer) swatchSetsContainer.innerHTML = "";
      updateLivePreview();
    } else if (kind === "drip") {
      resetDripState();
      updateLivePreview();
    }

    updateVariantId();
    updatePricePartial();
    validate();
    syncResetControls();
  }

  function hydrateSwatches(root) {
    const rows = root.querySelectorAll(".swatch-row");
    rows.forEach(row => {
      const candidates = row.querySelectorAll(".swatch");
      candidates.forEach(el => {
        const img = el.querySelector("img");
        const name =
          el.dataset?.colourName ||
          (img ? img.alt : "") ||
          (el.textContent || "").trim();
        if(!name) return;
        el.classList.add("swatch");
        if(!el.dataset.colourName) el.dataset.colourName = name;
        el.setAttribute("role","button");
        if(!el.hasAttribute("aria-pressed")) el.setAttribute("aria-pressed","false");
      });
    });
  }

function makeSwatchSet(heading, maxSelect, role = "") {
  const clone = prototype.cloneNode(true);
  clone.style.display = "";
  const headingEl = clone.querySelector(".swatch-heading");
  headingEl.textContent = heading;
  clone.dataset.maxSelect = maxSelect;
  if (role) {
    clone.dataset.role = role;
    headingEl.dataset.role = role;
  }

  const row = clone.querySelector(".swatch-row");
  row.innerHTML = "";

  if (swatchSource) {
    // Try to find sub-category frames first
    let subCats = swatchSource.querySelectorAll(".sub-swatch-category");

    // Fallback: if snippet only has .swatch elements (no sub-categories)
    if (!subCats.length) subCats = swatchSource.querySelectorAll(".swatch");

    if (subCats.length) {
      subCats.forEach(cat => {
        const catClone = cat.cloneNode(true);
        row.appendChild(catClone);
      });
    } else {
      // Fallback — no categories at all, just a message
      const p = document.createElement("p");
      p.textContent = "No swatches available.";
      p.style.color = "#aaa";
      row.appendChild(p);
    }
  }

  hydrateSwatches(clone);
  return clone;
}

  function ensureCustomPanelVisible() {
    if (customPanel && customPanel.style.display === "none") {
      customPanel.style.display = "";
    }
  }

/* ---------- FIXED Live Preview (clickable) ---------- */
function updateLivePreview() {
  if (!livePreview) return;

  const selectedImgs = swatchSetsContainer.querySelectorAll(".swatch.active img");
  const surpriseSelected = isSurpriseSelected();
  const count = getSelectedColourCount();
  const style = surpriseSelected ? "" : activePourStyle();

  // Reset preview
  livePreview.innerHTML = "";
  const frag = document.createDocumentFragment();

  // Always clean up any old drip preview
  livePreview.querySelectorAll(".preview-drip").forEach(d => d.remove());

  // Helper: make a preview swatch clickable -> jump to the *actual* active swatch
  function makePreviewClickable(wrapper) {
    wrapper.style.cursor = "pointer";

    wrapper.addEventListener("click", () => {
      const label = (wrapper.getAttribute("data-label") || "").toLowerCase();
      if (!label) return;

      const allSets = document.querySelectorAll("#swatch-sets .swatch-set");
      let targetSet = null;

      // Find the correct swatch set by its heading (Tip / Shaft / Base)
      allSets.forEach(set => {
        const heading = (set.querySelector(".swatch-heading")?.textContent || "")
          .toLowerCase();
        if (heading.includes(label)) targetSet = set;
      });

      if (!targetSet) return;

      // Expand that set first (so scroll position is correct)
      if (window.expandSwatchSet) window.expandSwatchSet(targetSet);

      // Now jump directly to the active swatch inside that set (if any)
      const activeSwatch =
        targetSet.querySelector(".swatch.active") ||
        targetSet.querySelector(".swatch");

      const scrollTarget = activeSwatch || targetSet;

      scrollTarget.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    });
  }

  // Placeholder if nothing selected
  if (selectedImgs.length === 0) {
    const placeholder = document.createElement("div");
    placeholder.className = "preview-swatch";
    placeholder.innerHTML = `
      <img src="${config.placeholderUrl}"
           alt="${(window.customizerStrings && window.customizerStrings.preview_img_alt) || 'Live preview'}">
    `;
    frag.appendChild(placeholder);
  } else {
    // Build preview tiles from selected swatches
    selectedImgs.forEach((img) => {
      const wrapper = document.createElement("div");
      wrapper.className = "preview-swatch";

      const clone = img.cloneNode(true);
      wrapper.appendChild(clone);

      // Add colour name overlay (bottom-right)
      const colourName = img.alt || "";
      if (colourName) {
        const nameTag = document.createElement("span");
        nameTag.className = "preview-colour-name";
        nameTag.textContent = colourName;
        wrapper.appendChild(nameTag);
      }

      // Work out which area this tile represents (Tip/Shaft/Base)
      let labelText = (window.customizerStrings && window.customizerStrings.colour_generic) || "Colour";
      const set = img.closest(".swatch-set");
      if (set) {
        const headingEl = set.querySelector(".swatch-heading");
        const role = headingEl?.dataset?.role || "";
        const heading = (headingEl?.textContent || "").trim().toLowerCase();
        if (role === "tip" || heading.includes("tip") || heading.includes("spitze")) {
          labelText = (window.customizerStrings && window.customizerStrings.tip) || "Tip";
        } else if (role === "shaft" || heading.includes("shaft") || heading.includes("schaft")) {
          labelText = (window.customizerStrings && window.customizerStrings.shaft) || "Shaft";
        } else if (role === "base" || heading.includes("base") || heading.includes("basis")) {
          labelText = (window.customizerStrings && window.customizerStrings.base) || "Base";
        }
      }

      wrapper.setAttribute("data-label", labelText);
      makePreviewClickable(wrapper); // 👈 make it open the right swatch group
      frag.appendChild(wrapper);
    });
  }

  // Drip colour preview (if enabled)
  if (dripEnabled && dripColour) {
    const dripWrapper = document.createElement("div");
    dripWrapper.className = "preview-swatch preview-drip";

    const dripSwatchEl = document.querySelector("#drip-swatch-sets .swatch.active img");
    if (dripSwatchEl) {
      const dripImg = dripSwatchEl.cloneNode(true);
      dripWrapper.appendChild(dripImg);

      const dripName = dripImg.alt || dripColour || "";
      if (dripName) {
        const nameTag = document.createElement("span");
        nameTag.className = "preview-colour-name";
        nameTag.textContent = dripName;
        dripWrapper.appendChild(nameTag);
      }
    }

    const dripLabel = (window.customizerStrings && window.customizerStrings.drip_colour_label) || "Drip";
    dripWrapper.setAttribute("data-label", dripLabel);

    // Make drip preview clickable -> open drip swatch list
    dripWrapper.style.cursor = "pointer";
    dripWrapper.addEventListener("click", () => {
      const dripSet = document.getElementById("drip-swatch-sets");
      if (!dripSet) return;
      if (window.expandSwatchSet) window.expandSwatchSet(dripSet);
      dripSet.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    frag.appendChild(dripWrapper);
  }

  livePreview.appendChild(frag);
}


/* ---------- Render swatch sets by count + style ---------- */
function renderSwatchSets(count, style) {
  ensureCustomPanelVisible();
  swatchSetsContainer.innerHTML = "";
  clearProperties();
  updateLivePreview();

  // ---- ONE COLOUR ----
  if (count === 1) {
    pourWrapper.style.display = "none";
    swatchSetsContainer.appendChild(
      makeSwatchSet(window.customizerStrings.swatch_choose_one, 1)
    );
    return;
  }

  // ---- MULTICOLOUR ----
  pourWrapper.style.display = "";

  if (!style) return;

  // ======================
  // 2 COLOURS
  // ======================
  if (count === 2) {
    if (style === "ribbon-marble") {
      swatchSetsContainer.appendChild(
        makeSwatchSet(window.customizerStrings.swatch_choose_two_marble, 2)
      );
    }

    else if (style === "ribbon-shade") {
      const tipSet = makeSwatchSet(window.customizerStrings.swatch_tip, 1, "tip");
      swatchSetsContainer.appendChild(tipSet);

      const baseSet = makeSwatchSet(window.customizerStrings.swatch_base, 1, "base");
      swatchSetsContainer.appendChild(baseSet);
    }

    else if (style === "split") {
      swatchSetsContainer.appendChild(
        makeSwatchSet(window.customizerStrings.swatch_shaft, 1, "shaft")
      );
      swatchSetsContainer.appendChild(
        makeSwatchSet(window.customizerStrings.swatch_base, 1, "base")
      );
    }
  }

  // ======================
  // 3 COLOURS
  // ======================
  if (count === 3) {
    if (style === "ribbon-marble") {
      swatchSetsContainer.appendChild(
        makeSwatchSet(window.customizerStrings.swatch_choose_three_marble, 3)
      );
    }

    else if (style === "ribbon-shade") {
      const tipSet = makeSwatchSet(window.customizerStrings.swatch_tip, 1, "tip");
      swatchSetsContainer.appendChild(tipSet);

      const shaftSet = makeSwatchSet(window.customizerStrings.swatch_shaft, 1, "shaft");
      swatchSetsContainer.appendChild(shaftSet);

      const baseSet = makeSwatchSet(window.customizerStrings.swatch_base, 1, "base");
      swatchSetsContainer.appendChild(baseSet);
    }

    else if (style === "split") {
      swatchSetsContainer.appendChild(
        makeSwatchSet(
          window.customizerStrings.swatch_shaft_up_to_2 || "Shaft (up to 2)",
          2,
          "shaft"
        )
      );
      swatchSetsContainer.appendChild(
        makeSwatchSet(
          window.customizerStrings.swatch_base_up_to_2 || "Base (up to 2)",
          2,
          "base"
        )
      );
    }
  }

  // ===== Activate cascading visibility + glow =====
  setTimeout(updateShadeAndGlow, 100);
}

/* ---------- Validation ---------- */
function validate() {
  const hasVariant  = !!hiddenInput.value;
  const hasFirmness = !!propFirmness.value;
  let coloursOk = false;
  let pourOk    = true;

  const surpriseSelected = isSurpriseSelected();
  const count = getSelectedColourCount();
  const style = surpriseSelected ? "" : activePourStyle();

  // =========================
  // 1) COLOUR VALIDATION
  // =========================
  if (surpriseSelected) {
    coloursOk = true;
  } else if (count === 0) {
    coloursOk = true;
  } else if (count === 1) {
    coloursOk = swatchSetsContainer.querySelectorAll(".swatch.active").length === 1;
  } else if (count === 2) {
    if (!style) pourOk = false;

    if (style === "split") {
      // 2-colour split = 1 Shaft + 1 Base
      const sets = swatchSetsContainer.querySelectorAll(".swatch-set");
      if (sets.length >= 2) {
        const shaft = sets[0].querySelectorAll(".swatch.active").length;
        const base  = sets[1].querySelectorAll(".swatch.active").length;
        coloursOk = (shaft === 1 && base === 1);
      }
    } else {
      // normal 2-colour
      coloursOk = swatchSetsContainer.querySelectorAll(".swatch.active").length === 2;
    }
  } else if (count === 3) {
    if (!style) pourOk = false;

    if (style === "split") {
      // 3-colour split: exactly 3 total, pattern 2+1 or 1+2
      const sets = swatchSetsContainer.querySelectorAll(".swatch-set");
      if (sets.length >= 2) {
        const shaft = sets[0].querySelectorAll(".swatch.active").length;
        const base  = sets[1].querySelectorAll(".swatch.active").length;
        const total = shaft + base;

        if (total > 3) {
          const lastClicked = swatchSetsContainer.querySelector(".swatch.last-clicked");
          if (lastClicked) {
            lastClicked.classList.remove("active");
            lastClicked.setAttribute("aria-pressed", "false");
            lastClicked.classList.remove("last-clicked");
          }
        }

        coloursOk =
          (total === 3) &&
          ((shaft === 2 && base === 1) || (shaft === 1 && base === 2));
      }
    } else {
      // normal 3-colour
      coloursOk = swatchSetsContainer.querySelectorAll(".swatch.active").length === 3;
    }
  }

  // =========================
  // 2) SAVE PROPERTIES
  // =========================
  if (hasVariant && hasFirmness) {
    // pour style
    propPour.value = (count > 1 && style) ? style : "";

    // clear everything first
    if (propC1) propC1.value = "";
    if (propC2) propC2.value = "";
    if (propC3) propC3.value = "";

    if (propTip)   propTip.value   = "";
    if (propShaft) propShaft.value = "";
    if (propBase)  propBase.value  = "";

    if (propSplitShaftColour) propSplitShaftColour.value = "";
    if (propSplitBaseColour)  propSplitBaseColour.value  = "";

    const sets = Array.from(swatchSetsContainer.querySelectorAll(".swatch-set"));
    const allSelected = Array.from(swatchSetsContainer.querySelectorAll(".swatch.active"));

    const getName = (sw) => {
      if (!sw) return "";
      return (
        sw.dataset.colourName ||
        sw.querySelector("img")?.alt ||
        (sw.textContent || "").trim()
      );
    };

    const allNames = allSelected.map(getName);

    // helper: Colour 1 / 2 / 3 generic
    const setGenericColours = () => {
      if (propC1) propC1.value = allNames[0] || "";
      if (propC2) propC2.value = allNames[1] || "";
      if (propC3) propC3.value = allNames[2] || "";
    };

    // helper: find shade set by role="tip/shaft/base"
    const getShadeNameByRole = (roleKey) => {
      let result = "";
      sets.forEach(set => {
        const heading = set.querySelector(".swatch-heading");
        if (!heading) return;
        const role = heading.dataset ? heading.dataset.role : "";
        if (role !== roleKey) return;
        const active = set.querySelector(".swatch.active");
        if (!active) return;
        const name = getName(active);
        if (name) result = name;
      });
      return result;
    };

    // ---------- CASES ----------
    // 1) single colour or marble (or no style) → Colour 1/2/3 only
    if (!style || style === "ribbon-marble" || count <= 1) {
      setGenericColours();
    }

    // 2) SHADE → Tip / Shaft / Base labels, NO generic Colour 1/2/3
    else if (style === "ribbon-shade") {
      if (sets.length < 2) {
        // broken UI – keep them empty
        propTip.value = "";
        propShaft.value = "";
        propBase.value = "";
      } else {
        const tipName   = getShadeNameByRole("tip");
        const shaftName = getShadeNameByRole("shaft");
        const baseName  = getShadeNameByRole("base");

        if (count === 2) {
          // 2-colour shade: tip + base
          propTip.value  = tipName || "";
          propBase.value = baseName || "";
          propShaft.value = ""; // not used
        }

        if (count === 3) {
          // 3-colour shade: tip + shaft + base
          propTip.value   = tipName   || "";
          propShaft.value = shaftName || "";
          propBase.value  = baseName  || "";
        }
      }
    }

    // 3) SPLIT → keep Colour 1/2/3 AND explicit Shaft / Base colours
    else if (style === "split") {
      // always keep generic list too (for your existing copy)
      setGenericColours();

      const findSetByRole = (role) =>
        sets.find(set => {
          const h = set.querySelector(".swatch-heading");
          return set.dataset.role === role || h?.dataset?.role === role;
        });

      const shaftSet = findSetByRole("shaft") || sets[0];
      const baseSet = findSetByRole("base") || sets[1];

      if (shaftSet) {
        const shaftSelected = Array
          .from(shaftSet.querySelectorAll(".swatch.active"))
          .map(getName)
          .filter(Boolean);
        if (shaftSelected.length) {
          // join in case there are 2 shaft colours
          propSplitShaftColour.value = shaftSelected.join(", ");
        }
      }

      if (baseSet) {
        const baseSelected = Array
          .from(baseSet.querySelectorAll(".swatch.active"))
          .map(getName)
          .filter(Boolean);
        if (baseSelected.length) {
          // join in case there are 2 base colours
          propSplitBaseColour.value = baseSelected.join(", ");
        }
      }
    }

    // 4) unknown style fallback → just generic colours
    else {
      setGenericColours();
    }
  }

// =========================
// 3) ENABLE / DISABLE BUTTON
// =========================
const ok = hasVariant && hasFirmness && pourOk && coloursOk;
addToCartBtn.disabled = !ok;

if (ok) {
  setCartVisibility(true);
} else if (!hasVariant) {
  setCartVisibility(false, window.customizerStrings.validation_choose_all);
} else if (!hasFirmness) {
  setCartVisibility(false, window.customizerStrings.validation_choose_firmness);
} else if (count > 1 && !style) {
  setCartVisibility(false, window.customizerStrings.validation_choose_pour_style);
} else {
  setCartVisibility(false, window.customizerStrings.validation_complete_colours);
}

  // =========================
  // 4) INSTRUCTION TEXT
  // =========================
  if (instructionEl) {
    instructionEl.classList.remove("ready", "warning");
    hint.classList.remove("ready", "warning");

    if (!count) {
      instructionEl.textContent = window.customizerStrings.instr_start;
    } else if (count === 1) {
      instructionEl.textContent = coloursOk
        ? window.customizerStrings.instr_one_ready
        : window.customizerStrings.instr_one_pick;
      instructionEl.classList.add(coloursOk ? "ready" : "warning");
    } else if (count === 2) {
      if (!style) {
        instructionEl.textContent = window.customizerStrings.instr_two_choose_style;
        instructionEl.classList.add("warning");
      } else if (style === "ribbon-marble") {
        instructionEl.textContent = coloursOk
          ? window.customizerStrings.instr_two_marble_ready
          : window.customizerStrings.instr_two_marble_pick;
      } else if (style === "ribbon-shade") {
        instructionEl.textContent = coloursOk
          ? window.customizerStrings.instr_two_shade_ready
          : window.customizerStrings.instr_two_shade_pick;
      } else if (style === "split") {
        instructionEl.textContent = coloursOk
          ? (window.customizerStrings.instr_two_split_ready || "Ready—pick one for Shaft & one for Base")
          : (window.customizerStrings.instr_two_split_pick  || "Pick one for Shaft & one for Base");
      }
      instructionEl.classList.add(coloursOk ? "ready" : "warning");
    } else if (count === 3) {
      if (!style) {
        instructionEl.textContent = window.customizerStrings.instr_three_choose_style;
        instructionEl.classList.add("warning");
      } else if (style === "ribbon-marble") {
        instructionEl.textContent = coloursOk
          ? window.customizerStrings.instr_three_marble_ready
          : window.customizerStrings.instr_three_marble_pick;
      } else if (style === "ribbon-shade") {
        instructionEl.textContent = coloursOk
          ? window.customizerStrings.instr_three_shade_ready
          : window.customizerStrings.instr_three_shade_pick;
      } else if (style === "split") {
        instructionEl.textContent = coloursOk
          ? (window.customizerStrings.instr_three_split_ready || "Ready—choose 2 Shaft & 1 Base (or 1 Shaft & 2 Base)")
          : (window.customizerStrings.instr_three_split_pick  || "Choose 2 Shaft & 1 Base (or 1 Shaft & 2 Base)");
      }
      instructionEl.classList.add(coloursOk ? "ready" : "warning");
    }
  }

  // =========================
  // 5) DRIP REQUIREMENT
  // =========================
  if (!surpriseSelected && dripBlock && dripBlock.style.display !== "none" && dripEnabled) {
  const hasDripColour = !!dripColour;
  if (!hasDripColour) {
    addToCartBtn.disabled = true;
    setCartVisibility(
      false,
      (window.customizerStrings && window.customizerStrings.pick_one_colour)
      || "Pick one colour for the drip."
    );
  }
}
}

function normalizeOptionName(name) {
  if (!name) return "";
  const lower = name.toLowerCase().trim();

  /* ============================================
     SIZE  — European languages + Japanese
     ============================================ */
  const sizeWords = [
    // English
    "size",
    // French
    "taille",
    // Spanish
    "tamaño",
    // Portuguese
    "tamanho",
    // Italian
    "misura",
    // German
    "größe", "groesse", "grosse",
    // Dutch
    "maat",
    // Danish / Norwegian
    "størrelse", "storrelse",
    // Swedish
    "storlek",
    // Finnish
    "koko",
    // Polish
    "rozmiar",
    // Czech / Slovak
    "velikost",
    // Hungarian
    "méret", "meret",
    // Romanian
    "mărime", "marime",
    // Greek
    "μέγεθος", "megethos",
    // Bulgarian
    "размер", "razmer",
    // Croatian / Serbian / Bosnian / Slovene
    "veličina", "velicina",
    // Lithuanian
    "dydis",
    // Latvian
    "izmērs", "izmēri", "izmers",
    // Estonian
    "suurus",
    // Japanese
    "サイズ", "さいず", "寸法", "大きさ"
  ];

  if (sizeWords.includes(lower)) return "size";

  /* ============================================
     BASE — European languages + Japanese
     ============================================ */
  const baseWords = [
    // English
    "base",
    // French
    "fond", "base",
    // Spanish / Portuguese
    "base",
    // Italian
    "base",
    // German
    "basis", "sockel",
    // Dutch
    "basis",
    // Nordic
    "base", "bunn", "botten", "bas",
    // Finnish
    "pohja",
    // Polish
    "podstawa",
    // Czech / Slovak
    "základ", "zaklad", "spodek",
    // Hungarian
    "alap",
    // Romanian
    "bază", "baza",
    // Greek
    "βάση", "vasi",
    // Bulgarian
    "основа", "osnova",
    // Croatian / Serbian / Slovene
    "baza",
    // Baltic
    "pamata", "pamats", "põhi",
    // Japanese
    "ベース", "べーす", "台座", "基部"
  ];

  if (baseWords.includes(lower)) return "base";


  /* ======================================================
     HOW MANY COLOURS? — European languages + Japanese
     ====================================================== */

  // Detect the *question* part
  const howManyWords = [
    "how many", "how many colours", "how many colors",
    "hoeveel", "hoeveel kleuren",
    "combien", "combien de couleurs",
    "cuántos", "cuantos", "cuántos colores",
    "quantas cores", "quantos cores", "quantos colores",
    "quante", "quanti colori",
    "wie viele", "wieviele farben",
    "hvor mange farver",
    "hur många färger",
    "hvor mange farger",
    "kuinka monta väriä",
    "ile kolorów", "ile kolorow",
    "kolik barev",
    "koliko boja",
    "koliko barv",
    "câte culori", "cate culori",
    "πόσα χρώματα", "posa hromata",
    "колко цвята", "kolko cvyata",
    // Japanese
    "何色", "なんしょく", "いくつの色", "カラー数", "カラー数は？"
  ];

  // Detect "colour" itself
  const colourWords = [
    "colour", "color", "couleur", "colores", "colours", "cores",
    "farben", "farver", "färger", "farger", "väriä", "barvy",
    "boje", "barve", "culori", "kleur", "kleuren", "χρώματα", "цвета", "カラー", "色"
  ];

  const hasHowMany = howManyWords.some(w => lower.includes(w));
  const hasColour = colourWords.some(w => lower.includes(w));

  if (hasHowMany && hasColour) return "colorcount";

  /* fallback: return cleaned lower string */
  return lower;
}

const canonicalValueMap = {
  size: {
    // already slugs or single words – OK as-is
    "cute": "cute",
    "schattig": "cute",
    "uroczy": "cute",
    "slodki": "cute",
    "sliczny": "cute",
    "mignon": "cute",
    "lindo": "cute",
    "mignon(ne)": "cute",          // slugify → "mignon(ne)"
    "bonito": "cute",
    "sizeless": "cute",
    "söt": "cute",
"sot": "cute",
"herkulisk": "herculean",
"mammut": "mammoth",
"gigantisk": "gargantuan",

    "herculean": "herculean",
    "herkulisch": "herculean",
    "herkulesowy": "herculean",
    "herculeen": "herculean",
    "hercúleo": "herculean",
    "herculéen": "herculean",
    "herkulisch": "herculean",
    "ヘルキュリン": "herculean",

    "mammoth": "mammoth",
    "mammoet": "mammoth",
    "mamút": "mammoth",
    "mamut": "mammoth",
    "mammut": "mammoth",
    "マンモス": "mammoth",

    "gargantuan": "gargantuan",
    "gigantisch": "gargantuan",
    "gigantyczny": "gargantuan",
    "gargantuiczny": "gargantuan",
    "ogromny": "gargantuan",
    "olbrzymi": "gargantuan",
    "gargantuesque": "gargantuan",
    "riesig": "gargantuan",
    "gargantuesco": "gargantuan",
    "ガルガンチュアン": "gargantuan"
  },

  base: {
    // FLAT
    "flat": "flat",
    "plaska": "flat",
    "plaski": "flat",
    "flach": "flat",
    "plat": "flat",
    "plate": "flat",
    "plana": "flat",
    "departamento": "flat",
    "llano": "flat",
    "platt": "flat",
    "フラット": "flat",

    // SUCTION CUP
    "suction-cup": "suction-cup",    // English option already slug
    "met-zuignap": "suction-cup",
    "met zuignap": "suction-cup",
    "z-przyssawka": "suction-cup",
    "przyssawka": "suction-cup",
    "saugnapf": "suction-cup",
    "ventouse": "suction-cup",
    "ventosa": "suction-cup",
    "sugkopp": "suction-cup",
    "吸盤": "suction-cup",

    // PLUG-COMPATIBLE — all keys must be SLUGS (with dashes)
    "plug-compatible": "plug-compatible",              // English
    "plug-compatibel": "plug-compatible",
    "kompatybilna-z-korkiem": "plug-compatible",
    "kompatybilna-z-korkiem-analnym": "plug-compatible",
    "kompatybilna-z-plugiem": "plug-compatible",
    "kompatybilny-z-korkiem": "plug-compatible",
    "pluggkompatibel": "plug-compatible",
    "kompatybilny-z-korkiem-analnym": "plug-compatible",
    "plug-kompatibel": "plug-compatible",             // German
    "compatible-avec-les-prises": "plug-compatible",   // “compatible avec les prises”
    "compatible-avec-les-prise": "plug-compatible",    // if typo / singular
    "compatible-avec-prise": "plug-compatible",
    "compatible-avec-prises": "plug-compatible",

    "compatible-con-enchufes": "plug-compatible",
    "compatible-con-plug": "plug-compatible",
    "compatible-con-enchufes": "plug-compatible",      // ES: compatible con enchufes
    "compatible-con-enchufe": "plug-compatible",       // singular
    "compatible-con-enchufes-y-mas": "plug-compatible",// in case translator adds bits

    "compatible-plug": "plug-compatible",              // already a slug
    "compatible-plug-in": "plug-compatible",

    "プラグ対応": "plug-compatible",                      // Japanese
    "compatible-avec-plug": "plug-compatible"
  }
};

function canonicalVariantValueByIndex(index, value) {
  const optionName = groupOrder[index] || (config.optionNames && config.optionNames[index]) || "";
  const norm = normalizeOptionName(optionName);
  const rawValue = slugify(value);
  const canonicalRawValue = canonicalSlugify(value);
  const map = canonicalValueMap[norm] || {};
  const mappedValue = map[rawValue] || map[canonicalRawValue];

  if (mappedValue) return mappedValue;

  if (norm === "base") {
    if (canonicalRawValue.includes("przyssawka") || canonicalRawValue.includes("zuignap")) return "suction-cup";
    if (canonicalRawValue.includes("plaska") || canonicalRawValue === "plat") return "flat";
    if (canonicalRawValue.includes("korkiem") || canonicalRawValue.includes("plug") || canonicalRawValue.includes("compatibel")) return "plug-compatible";
  }

  if (norm === "size") {
    if (canonicalRawValue.includes("herkul")) return "herculean";
    if (canonicalRawValue.includes("mamut") || canonicalRawValue.includes("mammoet")) return "mammoth";
    if (canonicalRawValue.includes("gigant") || canonicalRawValue.includes("gargant") || canonicalRawValue.includes("ogrom") || canonicalRawValue.includes("olbrzym")) return "gargantuan";
    if (canonicalRawValue.includes("urocz") || canonicalRawValue.includes("slodk") || canonicalRawValue.includes("sliczn") || canonicalRawValue.includes("schattig")) return "cute";
  }

  return canonicalRawValue || rawValue || String(value || "").toLowerCase().trim();
}



optionBtns.forEach(btn=>{
  btn.addEventListener("click", function(){
    const group = this.getAttribute("data-option-group");
    form.querySelectorAll(`.option-btn[data-option-group="${group}"]`)
      .forEach(b=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
    this.classList.add("active");
    this.setAttribute("aria-pressed","true");

    const og = this.getAttribute("data-original-option");
    const val = slugify(this.dataset.value);
    const handle = slugify(config.productHandle);

    const norm = normalizeOptionName(og);

// === Language-proof preview key ===
if (norm === "size" || norm === "base") {
  const rawValue = slugify(this.dataset.value); // translated text
  const canonicalRawValue = canonicalSlugify(this.dataset.value);
  const canonical = canonicalValueMap[norm][rawValue] || canonicalValueMap[norm][canonicalRawValue] || canonicalRawValue || rawValue;

  const key = `${handle}_${norm}_${canonical}`;
  const preview = document.getElementById(`${norm}-preview`);

  if (preview) {
    const src = window.variantImages[key];
    preview.innerHTML = src
      ? `<img src="${src}" width="280" height="280" alt="${norm} preview">`
      : "";
  }
}

    // Special handling for colour count, including the Shopify Surprise! variant.
    if (group === "colorcount" || norm === "colorcount") {
      applyColourCountSelection(this);
    }

updateVariantId();
syncCustomisationWithVariantSelection();
updatePricePartial();
validate();
  });
});

  firmnessBtns.forEach(btn=>{
    btn.addEventListener("click", function(){
      firmnessBtns.forEach(b=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
      this.classList.add("active");
      this.setAttribute("aria-pressed","true");
      propFirmness.value = this.dataset.value || "";
      validate();
    });
  });

  pourBtns.forEach(btn=>{
    btn.addEventListener("click", function(){
      pourBtns.forEach(b=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
      this.classList.add("active");
      this.setAttribute("aria-pressed","true");
      const countBtn = getActiveColourCountButton();
      if (countBtn && !isSurpriseColourButton(countBtn)) {
        renderSwatchSets(getSelectedColourCount(), this.dataset.pourStyle);
      }
      validate();
    });
  });
// Track last clicked swatch (for split limit)
swatchSetsContainer.addEventListener("click", e => {
  const sw = e.target.closest(".swatch");
  if (sw) {
    document.querySelectorAll(".swatch").forEach(s => s.classList.remove("last-clicked"));
    sw.classList.add("last-clicked");
  }
}, true);
  swatchSetsContainer.addEventListener("click", function(e) {
  const sw = e.target.closest(".swatch");
  if (!sw) return;
  const setEl = sw.closest(".swatch-set");
  if (!setEl) return;

  const max = parseInt(setEl.dataset.maxSelect || "1", 10);

  // === SPLIT 3-COLOUR ENFORCEMENT (run BEFORE activation) ===
  const style = activePourStyle();
  const count = getSelectedColourCount();

  if (style === "split" && count === 3) {
    const sets = swatchSetsContainer.querySelectorAll(".swatch-set");
    if (sets.length >= 2) {
      const shaftCount = sets[0].querySelectorAll(".swatch.active").length;
      const baseCount  = sets[1].querySelectorAll(".swatch.active").length;
      const total = shaftCount + baseCount;

      // Block before activating: if total already 3 and user tries another
      if (!sw.classList.contains("active") && total >= 3) {
        const msg = (window.customizerStrings && window.customizerStrings.split_three_limit_warning)
          || "You can only choose 3 colours total (2 Shaft + 1 Base or 1 Shaft + 2 Base).";
        if (instructionEl) {
          instructionEl.textContent = msg;
          instructionEl.classList.add("warning");
        }
        return; // ⛔ STOP — do not activate this swatch
      }
    }
  }

  // === Normal swatch toggle ===
  if (sw.classList.contains("active")) {
    sw.classList.remove("active");
    sw.setAttribute("aria-pressed", "false");
  } else {
    if (max === 1) {
      setEl.querySelectorAll(".swatch.active").forEach(b => {
        b.classList.remove("active");
        b.setAttribute("aria-pressed", "false");
      });
    }
    if (setEl.querySelectorAll(".swatch.active").length < max) {
      sw.classList.add("active");
      sw.setAttribute("aria-pressed", "true");
    }
  }

  updateLivePreview();
  validate();
// === Auto-collapse both sets when Split (3 colours) total reached ===
if (style === "split" && count === 3) {
  const sets = swatchSetsContainer.querySelectorAll(".swatch-set");
  if (sets.length >= 2) {
    const shaftCount = sets[0].querySelectorAll(".swatch.active").length;
    const baseCount  = sets[1].querySelectorAll(".swatch.active").length;
    const total = shaftCount + baseCount;
    if (total === 3 && window.collapseSwatchSet) {
      sets.forEach(set => {
        setTimeout(() => window.collapseSwatchSet(set), 300);
      });
    }
  }
}
  // ✅ auto-collapse when selection complete
  const maxSel = parseInt(setEl.dataset.maxSelect || "1", 10);
  const chosen = setEl.querySelectorAll(".swatch.active").length;
  if (chosen >= maxSel && window.collapseSwatchSet) {
    setTimeout(() => window.collapseSwatchSet(setEl), 300);
  }

  // Smoothly scroll back to the same swatch's "Show colours" button
  setTimeout(() => {
    const btn = setEl.querySelector(".show-more-swatches");
    if (btn) {
      btn.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, 500);
});


  /* Variant More Information accordion (incl. pour-style example) */
  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".variant-more-info-btn");
    if (!btn) return;
    const key = btn.dataset.info;
    const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);
    if (!target) return;

    const isOpen = target.classList.contains("open");

    // Reset all sections
    document.querySelectorAll(".variant-more-info-content").forEach(section => {
      section.classList.remove("open");
    });
    document.querySelectorAll(".variant-more-info-btn").forEach(b => {
      const isExampleButton = b.dataset.info === "pour-style" || b.dataset.info === "drip-effect-example";

      if (isExampleButton) {
        b.textContent = window.customizerStrings.pour_show_example;
      } else {
        b.textContent = window.customizerStrings.more_info;
      }
      b.setAttribute("aria-expanded", "false");
    });

    // Open the one clicked (if not already open)
    if (!isOpen) {
      target.classList.add("open");
      const isExampleButton = btn.dataset.info === "pour-style" || btn.dataset.info === "drip-effect-example";

      if (isExampleButton) {
        btn.textContent = window.customizerStrings.pour_hide_example;
      } else {
        btn.textContent = window.customizerStrings.hide_info;
      }
      btn.setAttribute("aria-expanded", "true");
    }
  });
/* ==============================
   DYNAMIC PRICE UPDATE
============================== */
function updatePricePartial() {
  const priceEls = document.querySelectorAll(".sticky-cart-price");
  const selected = getSelectedVariantOptions();

  const currentCurrency = config.currency;
  const currentLocale = config.locale;

  function formatComputedMoney(amount) {
    return new Intl.NumberFormat(currentLocale, {
      style: "currency",
      currency: currentCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount / 100);
  }

  if (!selected.length) {
    priceEls.forEach(el => el.textContent = "");
    return;
  }

  const partial = variants.find(v =>
    selected.every(sel =>
      v.options.some((o, index) => canonicalVariantValueByIndex(index, o) === canonicalVariantValueByIndex(index, sel))
    )
  );

  if (!partial) return;

  const basePrice = Number(partial.price || 0);
  const dripPrice =
    (window.dripAddon && dripEnabled && window.dripAddon.variant_price)
      ? Number(window.dripAddon.variant_price)
      : 0;

  const total = basePrice + dripPrice;

  let html = "";
  if (
    partial.formatted_compare_at_price &&
    Number(partial.compare_at_price) > Number(partial.price)
  ) {
    html = `
      <span class="price--compare"><s>${partial.formatted_compare_at_price}</s></span>
      <span class="price--sale">${partial.formatted_price}</span>
    `;
  } else {
    html = partial.formatted_price || "";
  }

  if (dripPrice > 0) {
    const dripPriceLabel = window.customizerStrings?.drip_price_label || "Drip";
    const totalLabel = window.customizerStrings?.total_label || "Total";

    html += `
      <span class="ls-drip-price-addition">+ ${window.dripAddon.formatted_variant_price || formatComputedMoney(dripPrice)} (${dripPriceLabel})</span>
      <strong class="ls-price-total">${totalLabel}: ${formatComputedMoney(total)}</strong>
    `;
  }

  priceEls.forEach(el => {
    el.innerHTML = html;
  });
}
/* ========== CASCADING SHADE LOGIC + GLOW RESTRICTION ========== */
function updateShadeAndGlow() {
  const allSets = [...swatchSetsContainer.querySelectorAll(".swatch-set")];

  const findSet = (role) => allSets.find(set => {
    const h = set.querySelector(".swatch-heading");
    return set.dataset.role === role || h?.dataset?.role === role;
  });

  const tipSet   = findSet("tip");
  const shaftSet = findSet("shaft");
  const baseSet  = findSet("base");

  const tipChosen   = !!(tipSet && tipSet.querySelector(".swatch.active"));
  const shaftChosen = !!(shaftSet && shaftSet.querySelector(".swatch.active"));

  const tipGlow   = !!(tipSet && tipSet.querySelector(".swatch.active[data-colour-type='Glow']"));
  const shaftGlow = !!(shaftSet && shaftSet.querySelector(".swatch.active[data-colour-type='Glow']"));

  const pourStyle = activePourStyle();
  const colourCount = getSelectedColourCount();

  // remove previous helper messages
  document.querySelectorAll(".glow-helper-msg").forEach(m => m.remove());

  const addMsg = (setEl, msg) => {
    if (!setEl) return;
    const note = document.createElement("p");
    note.className = "glow-helper-msg";
    note.textContent = msg;
    note.style.color = "#f5c77d";
    note.style.fontSize = "0.9rem";
    note.style.textAlign = "center";
    note.style.margin = "0.5rem 0";
    const clampWrap = setEl.querySelector(".clamp-wrap");
if (clampWrap) {
  clampWrap.appendChild(note); // put inside collapsible area at bottom
} else {
  setEl.appendChild(note); // fallback if no clamp
}

  };

// Hide logic — only hide dependent sets for ribbon-shade styles
if (pourStyle === "ribbon-shade") {
  [shaftSet, baseSet].forEach(set => { if (set) set.style.display = "none"; });
} else if (pourStyle === "split") {
  // For split, always show both Shaft & Base sets
  if (shaftSet) shaftSet.style.display = "";
  if (baseSet) baseSet.style.display = "";
}

  // Reset Glow visibility
  allSets.forEach(set => {
    set.querySelectorAll(".swatch[data-colour-type='Glow']").forEach(sw => sw.style.display = "");
  });

  /* === 2-COLOUR SHADE === */
  if (pourStyle === "ribbon-shade" && colourCount === 2) {
    if (tipChosen && baseSet) {
      baseSet.style.display = ""; // reveal base only after tip chosen
      // hide base glow until tip glow chosen
      const baseGlows = baseSet.querySelectorAll(".swatch[data-colour-type='Glow']");
      if (!tipGlow) {
        baseGlows.forEach(sw => sw.style.display = "none");
        addMsg(baseSet, window.customizerStrings.glow_msg_select_tip || "Select Glow in the Tip first to unlock Glow for the Base.");
      }
    }
  }

  /* === 3-COLOUR SHADE === */
  if (pourStyle === "ribbon-shade" && colourCount === 3) {
    if (tipChosen && shaftSet) {
      shaftSet.style.display = ""; // show shaft after tip
      const shaftGlows = shaftSet.querySelectorAll(".swatch[data-colour-type='Glow']");
      if (!tipGlow) {
        shaftGlows.forEach(sw => sw.style.display = "none");
        addMsg(shaftSet, window.customizerStrings.glow_msg_select_tip || "Select Glow in the Tip first to unlock Glow for the Shaft.");
      }
    }
    if (shaftChosen && baseSet) {
      baseSet.style.display = ""; // show base after shaft
      const baseGlows = baseSet.querySelectorAll(".swatch[data-colour-type='Glow']");
      if (!shaftGlow) {
        baseGlows.forEach(sw => sw.style.display = "none");
        addMsg(baseSet, window.customizerStrings.glow_msg_select_shaft || "Select Glow in the Shaft first to unlock Glow for the Base.");
      }
    }
  }
/* === 2-COLOUR SPLIT === */
if (pourStyle === "split" && colourCount === 2) {
  if (shaftSet && baseSet) {
    baseSet.style.display = ""; // reveal base after shaft chosen
    const baseGlows = baseSet.querySelectorAll(".swatch[data-colour-type='Glow']");
    const shaftGlow = !!(shaftSet && shaftSet.querySelector(".swatch.active[data-colour-type='Glow']"));
    if (!shaftGlow) {
      baseGlows.forEach(sw => sw.style.display = "none");
      addMsg(baseSet, window.customizerStrings.glow_msg_select_shaft || "Select Glow in the Shaft first to unlock Glow for the Base.");
    }
  }
}

/* === 3-COLOUR SPLIT === */
if (pourStyle === "split" && colourCount === 3) {
  if (tipSet && shaftSet) {
    shaftSet.style.display = "";
    const shaftGlows = shaftSet.querySelectorAll(".swatch[data-colour-type='Glow']");
    const tipGlow = !!(tipSet && tipSet.querySelector(".swatch.active[data-colour-type='Glow']"));
    if (!tipGlow) {
      shaftGlows.forEach(sw => sw.style.display = "none");
      addMsg(shaftSet, window.customizerStrings.glow_msg_select_tip || "Select Glow in the Tip first to unlock Glow for the Shaft.");
    }
  }
  if (shaftSet && baseSet) {
    baseSet.style.display = "";
    const baseGlows = baseSet.querySelectorAll(".swatch[data-colour-type='Glow']");
    const shaftGlow = !!(shaftSet && shaftSet.querySelector(".swatch.active[data-colour-type='Glow']"));
    if (!shaftGlow) {
      baseGlows.forEach(sw => sw.style.display = "none");
      addMsg(baseSet, window.customizerStrings.glow_msg_select_shaft || "Select Glow in the Shaft first to unlock Glow for the Base.");
    }
  }
}

  // Hide whole glow category if nothing visible
  allSets.forEach(set => {
    const hasVisibleGlow = !!set.querySelector(".swatch[data-colour-type='Glow']:not([style*='display: none'])");
    const glowCat = set.querySelector(".sub-swatch-category.glow");
    if (glowCat) glowCat.style.display = hasVisibleGlow ? "" : "none";
  });
}

/* --- Hook --- */
function updateGlowAvailability() {
  // All glow behaviour is handled in updateShadeAndGlow for now.
  // This stays as a stub so setTimeout doesn't throw.
}
swatchSetsContainer.addEventListener("click", (e) => {
  if (e.target.closest(".swatch")) {
    setTimeout(updateShadeAndGlow, 150);
  }
});


// Listen for all swatch selections
swatchSetsContainer.addEventListener("click", (e) => {
  if (!e.target.closest(".swatch")) return;
  setTimeout(updateGlowAvailability, 150);
});

form.addEventListener("click", () => {
  window.setTimeout(syncResetControls, 0);
});

// === DRIP ADD-ON STATE ===
const dripBlock = document.getElementById("drip-addon-block");
const dripArea = document.getElementById("drip-swatch-area");
const dripHint = document.getElementById("drip-colour-hint");
let dripEnabled = false;           
let dripColour = "";               
let dripVariantId = (window.dripAddon && window.dripAddon.variant_id) || null;

// Build drip UI if configured
if (window.dripAddon && window.dripAddon.enabled && dripVariantId && dripBlock) {
  dripBlock.style.display = "";

  // --- Hydrate swatches (from hidden source) ---
  const dripRoot = document.getElementById("drip-swatch-source");
  const dripRow = document.querySelector("#drip-swatch-sets .swatch-row");
  if (dripRoot && dripRow) {
    // Clone the swatches from the hidden drip source
    const sourceGroup = dripRoot.querySelector(".swatch-groups");
    if (sourceGroup) {
      dripRow.innerHTML = sourceGroup.innerHTML;
      hydrateSwatches(dripRow);
    }
  }

  // --- Toggle buttons (Yes/No) ---
  const dripToggles = Array.from(document.querySelectorAll(".drip-toggle"));
dripToggles.forEach(btn => {
  btn.addEventListener("click", () => {
    dripToggles.forEach(b => {
      b.classList.remove("active");
      b.setAttribute("aria-pressed", "false");
    });
    btn.classList.add("active");
    btn.setAttribute("aria-pressed", "true");

    dripEnabled = btn.dataset.value === "yes";
    dripArea.style.display = dripEnabled ? "" : "none";
    if (dripHint) dripHint.style.display = dripEnabled ? "" : "none";

    if (!dripEnabled) {
      // clear selection state and preview immediately
      dripColour = "";
      document
        .querySelectorAll("#drip-swatch-sets .swatch.active")
        .forEach(s => {
          s.classList.remove("active");
          s.setAttribute("aria-pressed", "false");
        });
      // hard-remove any drip preview nodes now
      document
        .querySelectorAll("#live-preview .preview-drip")
        .forEach(n => n.remove());
    }

    // make preview re-render with current flags
    updateLivePreview();
    validate();
    updatePricePartial();
  });
});

  // --- Swatch click listener (visible area) ---
  const dripVisibleSet = document.getElementById("drip-swatch-sets");
  if (dripVisibleSet) {
    dripVisibleSet.addEventListener("click", (e) => {
      const sw = e.target.closest(".swatch");
      if (!sw) return;

      // single select behaviour
      dripVisibleSet.querySelectorAll(".swatch.active").forEach(s => {
        s.classList.remove("active");
        s.setAttribute("aria-pressed", "false");
      });

      sw.classList.add("active");
      sw.setAttribute("aria-pressed", "true");

      dripColour = sw.dataset.colourName || sw.querySelector("img")?.alt || "";
      updateLivePreview(); // refresh preview when drip colour chosen
      validate(); // recheck readiness to add to cart
      updatePricePartial(); // ✅ refresh sticky price after drip colour chosen
      // ✅ collapse drip set after 1 selection
if (window.collapseSwatchSet) {
  setTimeout(() => window.collapseSwatchSet(dripVisibleSet), 300);
}
// Smoothly scroll back to the drip "Show colours" button
setTimeout(() => {
  const btn = dripVisibleSet.querySelector(".show-more-swatches");
  if (btn) {
    btn.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, 500);

    });
  }
}
/* =============================================
   SPLIT POUR ENHANCER LOGIC — HARD RESET VERSION
============================================= */
let splitTarget = ""; // shaft or base
let splitStyle = "";
let topColour = "";
let bottomColour = "";

/* -------------------------------
   Hard reset + rebuild container
------------------------------- */
function rebuildSplitContainer() {
  const old = document.getElementById("split-enhancer-block");
  if (old && old.parentNode) old.remove();

  const container = document.createElement("div");
  container.id = "split-enhancer-block";
  container.className = "variant-frame";
  container.style.display = "none";
  container.innerHTML = `
    <div class="option-header">
      <label class="option-label" id="split-style-label"></label>
    </div>
    <div class="option-buttons">
      <button type="button" class="option-btn split-style-btn" data-value="ribbon-marble">
        ${window.customizerStrings?.pour_style_option_ribbon_marble || "Ribbon Marble"}
      </button>
      <button type="button" class="option-btn split-style-btn" data-value="ribbon-shade">
        ${window.customizerStrings?.pour_style_option_ribbon_shade || "Ribbon Shade"}
      </button>
    </div>

    <div id="split-toponly" style="display:none; margin-top:1rem;">
      <label class="option-label" id="split-toponly-label"></label>
      <div id="split-toponly-group" class="option-buttons" style="margin-top:0.5rem;"></div>
      <div id="split-auto-bottom" style="display:none; margin-top:0.5rem;"></div>
    </div>
  `;
  const dripBlock = document.getElementById("drip-addon-block");
  dripBlock?.parentNode?.insertBefore(container, dripBlock);
  return container;
}

/* -------------------------------
   Main visibility controller
------------------------------- */
function handleSplitVisibility() {
  const style = activePourStyle();
  const count = getSelectedColourCount();

  // always rebuild from scratch
  const splitBlock = rebuildSplitContainer();
  const splitStyleLabel = document.getElementById("split-style-label");
  const splitTopOnly = document.getElementById("split-toponly");
  const splitTopOnlyLabel = document.getElementById("split-toponly-label");
  const splitTopGroup = document.getElementById("split-toponly-group");
  const splitAutoBottom = document.getElementById("split-auto-bottom");

  // hidden fields
  const propSplitTarget = document.getElementById("prop-split-target");
  const propSplitStyle = document.getElementById("prop-split-style");
  const propSplitTop = document.getElementById("prop-split-top");
  const propSplitBottom = document.getElementById("prop-split-bottom");

  propSplitTarget.value = "";
  propSplitStyle.value = "";
  propSplitTop.value = "";
  propSplitBottom.value = "";

  // Only for split + 3 colours
  if (style !== "split" || count !== 3) return;

  const sets = swatchSetsContainer.querySelectorAll(".swatch-set");
  if (sets.length < 2) return;
  const shaftCount = sets[0].querySelectorAll(".swatch.active").length;
  const baseCount = sets[1].querySelectorAll(".swatch.active").length;
  splitTarget = shaftCount === 2 ? "shaft" : baseCount === 2 ? "base" : "";
  if (!splitTarget) return;

  propSplitTarget.value = splitTarget;
  splitBlock.style.display = "";
  splitStyleLabel.textContent =
    window.customizerStrings?.[`split_style_label_${splitTarget}`] ||
    `What style would you like for the ${splitTarget}?`;

  // --- Step 1: choose marble or shade
  const styleBtns = splitBlock.querySelectorAll(".split-style-btn");

  // Love Smiths rule:
  // 3 colours → Split → two colours assigned to the Base = Base can only use Ribbon Marble.
  // Ribbon Shade stays available when the two-colour split area is the Shaft.
  if (splitTarget === "base") {
    styleBtns.forEach(btn => {
      const isMarble = btn.dataset.value === "ribbon-marble";

      if (!isMarble) {
        btn.remove();
        return;
      }

      btn.classList.add("active");
      btn.setAttribute("aria-pressed", "true");
    });

    splitStyle = "ribbon-marble";
    propSplitStyle.value = splitStyle;
    splitTopOnly.style.display = "none";
    splitAutoBottom.style.display = "none";
    return;
  }

  styleBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      styleBtns.forEach(b => {
        b.classList.remove("active");
        b.setAttribute("aria-pressed", "false");
      });
      btn.classList.add("active");
      btn.setAttribute("aria-pressed", "true");

      splitStyle = btn.dataset.value;
      propSplitStyle.value = splitStyle;

      if (splitStyle === "ribbon-shade") {
        // wait for DOM to settle
        setTimeout(() => populateTopOnly(), 300);
      } else {
        splitTopOnly.style.display = "none";
        splitAutoBottom.style.display = "none";
      }
    });
  });

  /* -------------------------------
     Populate top colour buttons
  ------------------------------- */
  function populateTopOnly() {
    const targetSet = splitTarget === "shaft" ? sets[0] : sets[1];
    const selected = Array.from(targetSet.querySelectorAll(".swatch.active"));
    if (selected.length !== 2) return;

    const names = selected.map(sw => sw.dataset.colourName || sw.querySelector("img")?.alt || "");
    splitTopOnlyLabel.textContent =
      window.customizerStrings?.[`split_toponly_label_${splitTarget}`] ||
      `Which colour goes on top of the ${splitTarget}?`;
    splitTopGroup.innerHTML = "";
    splitAutoBottom.style.display = "none";

    names.forEach(name => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "option-btn split-choice-btn";
      btn.textContent = name;
      btn.dataset.value = name;
      btn.setAttribute("aria-pressed", "false");

      btn.addEventListener("click", () => {
        splitTopGroup.querySelectorAll(".split-choice-btn").forEach(b => {
          b.classList.remove("active");
          b.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");

        topColour = name;
        bottomColour = names.find(n => n !== name);
        propSplitTop.value = topColour;
        propSplitBottom.value = bottomColour;

        splitAutoBottom.style.display = "";
        splitAutoBottom.innerHTML = `
          <p class="option-label">
            ${
              window.customizerStrings?.[`split_bottom_auto_label_${splitTarget}`] ||
              `Bottom colour will be: ${bottomColour}`
            }
          </p>`;
      });
      splitTopGroup.appendChild(btn);
    });

    splitTopOnly.style.display = "";
  }
}

/* -------------------------------
   Trigger rebuild on relevant changes
------------------------------- */
document.addEventListener("click", (e) => {
  const isDrip = e.target.closest(".drip-toggle") || e.target.closest("#drip-swatch-sets");
  if (isDrip) return;

  if (
    e.target.closest(".pour-style-btn") ||
    e.target.closest(".option-btn[data-option-group='colorcount']") ||
    e.target.closest(".swatch")
  ) {
    setTimeout(() => handleSplitVisibility(), 400);
  }
});



// === UNIVERSAL SUBMIT HANDLER (handles drip + shade properly) ===
form.addEventListener("submit", async (e) => {
  e.preventDefault();

  // Safety: if button is disabled, don't do anything
  if (addToCartBtn.disabled) return;

  // Make sure we have a variant ID
  if (!hiddenInput.value) {
    console.warn("No variant selected");
    return;
  }

  addToCartBtn.disabled = true;

  const wantDrip =
    dripBlock &&
    dripBlock.style.display !== "none" &&
    dripEnabled &&
    dripVariantId;

  // ---------- Helpers ----------
  function getColourCount() {
    const btn = form.querySelector(
      '.option-btn[data-option-group="colorcount"].active'
    );
    if (!btn) return 0;
    const raw = btn.dataset.value || btn.textContent || "";
    const m = raw.match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  function getStyle() {
    return activePourStyle() || "";
  }

  function getSwatchName(sw) {
    if (!sw) return "";
    if (sw.dataset && sw.dataset.colourName) return sw.dataset.colourName;
    const img = sw.querySelector("img");
    if (img && img.alt) return img.alt;
    return (sw.textContent || "").trim();
  }

  function getSwatchSets() {
    return Array.prototype.slice.call(
      swatchSetsContainer.querySelectorAll(".swatch-set")
    );
  }

  const colourCount = getColourCount();
  const style = getStyle();
  const sets = getSwatchSets();

  // Collect all active swatches in DOM order
  const allActiveSwatches = [];
  sets.forEach(set => {
    const actives = set.querySelectorAll(".swatch.active");
    actives.forEach(sw => allActiveSwatches.push(sw));
  });

  // ---------- Build main product properties ----------
  const props = {};

  // Firmness and pour style: we trust your hidden inputs for those
  if (propFirmness && propFirmness.value) {
    props[config.strings.firmnessLabel] = propFirmness.value;
  }
  if (propPour && propPour.value) {
    props[config.strings.pourStyleLabel] = propPour.value;
  }

  // Helper: generic colours 1 / 2 / 3
  function setGenericColoursFrom(swArray) {
    const names = swArray.map(getSwatchName).filter(Boolean);
    if (names[0]) props[config.strings.colour1] = names[0];
    if (names[1]) props[config.strings.colour2] = names[1];
    if (names[2]) props[config.strings.colour3] = names[2];
  }

  // Helper: find shade set by role (tip/shaft/base)
  function getShadeNameByRole(roleKey) {
    let result = "";
    sets.forEach(set => {
      const heading = set.querySelector(".swatch-heading");
      if (!heading) return;

      const role = heading.dataset ? heading.dataset.role : "";
      if (role !== roleKey) return;

      const active = set.querySelector(".swatch.active");
      if (!active) return;

      const name = getSwatchName(active);
      if (name) result = name;
    });
    return result;
  }

  // --- Decide how to save colours ---
  if (colourCount <= 1 || !style || style === "ribbon-marble") {
    // 1 colour or marble → generic Colour 1/2/3 only
    setGenericColoursFrom(allActiveSwatches);
  } else if (style === "ribbon-shade") {
    // SHADE = store as Tip/Shaft/Base, no generic Colour 1/2/3
    const tipName = getShadeNameByRole("tip");
    const shaftName = getShadeNameByRole("shaft");
    const baseName = getShadeNameByRole("base");

    if (colourCount === 2) {
      // 2-colour shade: Tip + Base only
      if (tipName) {
        props[config.strings.cartTipColour] = tipName;
      }
      if (baseName) {
        props[config.strings.cartBaseColour] = baseName;
      }
    }

    if (colourCount === 3) {
      // 3-colour shade: Tip + Shaft + Base
      if (tipName) {
        props[config.strings.cartTipColour] = tipName;
      }
      if (shaftName) {
        props[config.strings.cartShaftColour] = shaftName;
      }
      if (baseName) {
        props[config.strings.cartBaseColour] = baseName;
      }
    }
  } else if (style === "split") {

    
    if (propSplitShaftColour && propSplitShaftColour.value) {
      props["Shaft colour"] = propSplitShaftColour.value;
    }
    if (propSplitBaseColour && propSplitBaseColour.value) {
      props["Base colour"] = propSplitBaseColour.value;
    }
    if (propSplitStyle && propSplitStyle.value) {
      props[config.strings.splitStyleLabel] = propSplitStyle.value;
    }
        if (propSplitTop && propSplitTop.value) {
      props[config.strings.splitTopLabel] = propSplitTop.value;
    }
    if (propSplitBottom && propSplitBottom.value) {
      props[config.strings.splitBottomLabel] = propSplitBottom.value;
    }
  } 

  // ---------- Drip linkage ----------
  // Generate a unique reference so the drip add-on can always be matched
  // to the correct custom dildo in the cart and Shopify order.
  let dripReference = "";

  if (wantDrip) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      dripReference = `DRIP-${window.crypto
        .randomUUID()
        .replace(/-/g, "")
        .slice(0, 6)
        .toUpperCase()}`;
    } else {
      dripReference = `DRIP-${Date.now()
        .toString(36)
        .slice(-6)
        .toUpperCase()}`;
    }

    // Visible on the custom dildo.
    props[config.strings.dripReferenceLabel] = dripReference;

    // Hidden internal linkage retained in Shopify order data.
    props._drip_reference = dripReference;
  }

  // ---------- Drip properties ----------
  const dripProps = {};

  if (wantDrip) {
    // Visible on the drip add-on.
    dripProps[config.strings.dripForLabel] = dripReference;

    if (dripColour) {
      dripProps[config.strings.dripColourLabel] = dripColour;
    }

    // Hidden internal linkage retained in Shopify order data.
    dripProps._drip_reference = dripReference;
  }

  // ---------- Build items array ----------
  const items = [
    {
      id: Number(hiddenInput.value),
      quantity: 1,
      properties: props
    }
  ];

  if (wantDrip) {
    items.push({
      id: Number(dripVariantId),
      quantity: 1,
      properties: dripProps
    });
  }

  // ---------- Send to cart ----------
  try {
    if (!window.LSAjaxCart || typeof window.LSAjaxCart.addItems !== "function") {
      throw new Error("Cart drawer is unavailable");
    }

    await window.LSAjaxCart.addItems(items, {
      open: true,
      trigger: addToCartBtn,
      source: "ls-custom-builder"
    });

    addToCartBtn.disabled = false;
  } catch (err) {
    console.error(err);
    addToCartBtn.disabled = false;
    hint.hidden = false;
    hint.textContent = config.strings.cartError;
  }
});

form.addEventListener("click", event => {
  const resetButton = event.target.closest(".ls-option-reset-btn");
  if (!resetButton) return;
  resetByKind(resetButton.dataset.resetKind || "");
});


refreshVariantAvailability();
hiddenInput.value = "";
addToCartBtn.disabled = true;
setCartVisibility(false);
validate();
syncResetControls();

  }

  function boot() {
    init(readConfig());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
